import React, { MouseEvent } from 'react'
import cn from 'classnames'

import { Typography } from 'src/shared/ui/Typography'
import { ClearIcon } from 'src/shared/icons'

import styles from './index.module.css'

type ClearButtonProps = {
  label?: string
  disabled?: boolean
  className?: string
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
}

export const ClearButton = ({ label, disabled, className, onClick }: ClearButtonProps) => {
  return (
    <button
      type="button"
      aria-label="Очистить"
      className={cn(styles.clearButton, { [styles.withLabel]: label })}
      onClick={onClick}
      disabled={disabled}
      tabIndex={-1}
    >
      <ClearIcon className={cn(styles.clearIcon, className)} />
      {label && <Typography view="semibold_14">{label}</Typography>}
    </button>
  )
}
